import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { NavIconButtons } from '@jisr-hr/design-system'
import { useOnClickOutside } from './helper'
import Styles from './Modal.module.css'

const Modal = ({
  active,
  trigger,
  header,
  footer,
  content,
  disableCloseOut,
  onClose,
  closeIcon,
  blankBackground,
  testId,
  headerClassName,
  contentClassName,
  modalClassName,
  footerClassName,
}) => {
  const [open, setOpen] = React.useState(false)
  const [moveOut, setMoveOut] = React.useState(false)
  const paper = React.useRef()

  const closeModal = () => {
    setMoveOut(true)
    setTimeout(() => {
      setOpen(false)
      setMoveOut(false)
      if (onClose) onClose()
    }, 500)
  }

  const handleModalToggle = () => {
    if (open) {
      closeModal()
    } else {
      setOpen(true)
    }
  }

  // on click outside
  useOnClickOutside(paper, handleModalToggle, !disableCloseOut)

  React.useEffect(() => {
    if (active && !moveOut) {
      setOpen(true)
    } else {
      closeModal()
    }
  }, [active])

  return (
    <>
      {trigger &&
        React.cloneElement(trigger, {
          onClick: handleModalToggle,
        })}

      {open &&
        ReactDOM.createPortal(
          <div
            className={classnames(
              Styles.modal,
              moveOut && Styles.moveOut,
              blankBackground && Styles.blankBackground,
              modalClassName,
            )}
            data-testid={testId}
          >
            <div
              className={classnames(Styles.modalPaper)}
              ref={paper}
            >
              <div className={classnames(Styles.modalHeader, headerClassName)}>
                <div
                  data-testid={`${testId}-header-content`}
                  className={classnames(Styles.modalHeaderContent)}
                >
                  {header}
                </div>
                <span
                  data-testid={`${testId}-close-button`}
                  className={classnames(Styles.closeBtn)}
                  onClick={handleModalToggle}
                >
                  {closeIcon || <NavIconButtons.Cross onClick={handleModalToggle} />}
                </span>
              </div>
              <div
                data-testid={`${testId}-content`}
                className={classnames(Styles.modalContent, contentClassName)}
              >
                {content}
              </div>
              {footer && (
                <div
                  data-testid={`${testId}-footer`}
                  className={classnames(Styles.modalFooter, footerClassName)}
                >
                  {footer}
                </div>
              )}
            </div>
          </div>,
          document.body,
        )}
    </>
  )
}

Modal.defaultProps = {
  onClose: () => {},
  testId: 'ds-modal',
}

Modal.propTypes = {
  footer: PropTypes.node,
  trigger: PropTypes.node,
  header: PropTypes.node,
  content: PropTypes.node,
  disableCloseOut: PropTypes.bool,
  active: PropTypes.bool,
  onClose: PropTypes.func,
  blankBackground: PropTypes.bool,
  closeIcon: PropTypes.node,
  testId: PropTypes.string,
  headerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  footerClassName: PropTypes.string,
  modalClassName: PropTypes.string,
}

export default Modal
